/**
 * GENERATED from research/taxonomy.json — do not edit by hand.
 * The taxonomy is fixed: every job description belongs to exactly one
 * category and exactly one subcategory beneath it.
 */
export const TAXONOMY = [
    {
        slug: 'software-engineering',
        name: 'Software Engineering',
        subcategories: [
            { slug: 'frontend', name: 'Frontend' },
            { slug: 'backend', name: 'Backend' },
            { slug: 'full-stack', name: 'Full Stack' },
            { slug: 'mobile-ios-android', name: 'Mobile (iOS/Android)' },
            { slug: 'devops-and-sre', name: 'DevOps & SRE' },
            { slug: 'platform-and-infrastructure', name: 'Platform & Infrastructure' },
            { slug: 'embedded-and-firmware', name: 'Embedded & Firmware' },
            { slug: 'qa-and-test-automation', name: 'QA & Test Automation' },
            { slug: 'game-development', name: 'Game Development' },
            { slug: 'blockchain-and-web3', name: 'Blockchain & Web3' },
            { slug: 'developer-relations', name: 'Developer Relations' },
            { slug: 'engineering-management', name: 'Engineering Management' },
        ],
    },
    {
        slug: 'data-and-ai',
        name: 'Data & AI',
        subcategories: [
            { slug: 'data-analyst', name: 'Data Analyst' },
            { slug: 'data-engineer', name: 'Data Engineer' },
            { slug: 'data-scientist', name: 'Data Scientist' },
            { slug: 'analytics-engineer', name: 'Analytics Engineer' },
            { slug: 'machine-learning-engineer', name: 'Machine Learning Engineer' },
            { slug: 'ai-ml-research', name: 'AI/ML Research' },
            { slug: 'mlops-and-ai-infrastructure', name: 'MLOps & AI Infrastructure' },
            { slug: 'business-intelligence', name: 'Business Intelligence' },
            { slug: 'data-architecture', name: 'Data Architecture' },
            { slug: 'ai-product-and-prompt-engineering', name: 'AI Product & Prompt Engineering' },
        ],
    },
    {
        slug: 'it-and-cybersecurity',
        name: 'IT & Cybersecurity',
        subcategories: [
            { slug: 'it-support-and-helpdesk', name: 'IT Support & Helpdesk' },
            { slug: 'systems-administration', name: 'Systems Administration' },
            { slug: 'network-engineering', name: 'Network Engineering' },
            { slug: 'cloud-engineering', name: 'Cloud Engineering' },
            { slug: 'security-engineering', name: 'Security Engineering' },
            { slug: 'security-operations-and-incident-response', name: 'Security Operations & Incident Response' },
            { slug: 'penetration-testing', name: 'Penetration Testing' },
            { slug: 'grc-risk-and-compliance', name: 'GRC, Risk & Compliance' },
            { slug: 'database-administration', name: 'Database Administration' },
            { slug: 'erp-and-enterprise-systems', name: 'ERP & Enterprise Systems' },
        ],
    },
    {
        slug: 'product-and-project-management',
        name: 'Product & Project Management',
        subcategories: [
            { slug: 'product-manager', name: 'Product Manager' },
            { slug: 'technical-product-manager', name: 'Technical Product Manager' },
            { slug: 'product-owner', name: 'Product Owner' },
            { slug: 'program-manager', name: 'Program Manager' },
            { slug: 'project-manager', name: 'Project Manager' },
            { slug: 'scrum-master-and-agile-coach', name: 'Scrum Master & Agile Coach' },
            { slug: 'business-analyst', name: 'Business Analyst' },
            { slug: 'product-operations', name: 'Product Operations' },
        ],
    },
    {
        slug: 'design-creative-and-media',
        name: 'Design, Creative & Media',
        subcategories: [
            { slug: 'ux-ui-design', name: 'UX/UI Design' },
            { slug: 'product-design', name: 'Product Design' },
            { slug: 'ux-research', name: 'UX Research' },
            { slug: 'graphic-design', name: 'Graphic Design' },
            { slug: 'brand-and-art-direction', name: 'Brand & Art Direction' },
            { slug: 'motion-graphics-and-animation', name: 'Motion Graphics & Animation' },
            { slug: 'video-production-and-editing', name: 'Video Production & Editing' },
            { slug: 'illustration', name: 'Illustration' },
            { slug: 'industrial-and-product-design', name: 'Industrial & Product Design' },
            { slug: 'writing-and-editing', name: 'Writing & Editing' },
            { slug: 'journalism', name: 'Journalism' },
            { slug: 'photography', name: 'Photography' },
            { slug: 'audio-and-sound-design', name: 'Audio & Sound Design' },
            { slug: 'creative-direction', name: 'Creative Direction' },
        ],
    },
    {
        slug: 'marketing-and-communications',
        name: 'Marketing & Communications',
        subcategories: [
            { slug: 'growth-and-performance-marketing', name: 'Growth & Performance Marketing' },
            { slug: 'content-marketing', name: 'Content Marketing' },
            { slug: 'seo-and-sem', name: 'SEO & SEM' },
            { slug: 'social-media', name: 'Social Media' },
            { slug: 'brand-marketing', name: 'Brand Marketing' },
            { slug: 'product-marketing', name: 'Product Marketing' },
            { slug: 'email-and-lifecycle', name: 'Email & Lifecycle' },
            { slug: 'marketing-analytics', name: 'Marketing Analytics' },
            { slug: 'public-relations-and-communications', name: 'Public Relations & Communications' },
            { slug: 'events-and-field-marketing', name: 'Events & Field Marketing' },
            { slug: 'affiliate-and-partnerships', name: 'Affiliate & Partnerships' },
            { slug: 'marketing-leadership', name: 'Marketing Leadership' },
        ],
    },
    {
        slug: 'sales-and-business-development',
        name: 'Sales & Business Development',
        subcategories: [
            { slug: 'sdr-bdr', name: 'SDR / BDR' },
            { slug: 'account-executive', name: 'Account Executive' },
            { slug: 'enterprise-sales', name: 'Enterprise Sales' },
            { slug: 'account-management', name: 'Account Management' },
            { slug: 'sales-engineering', name: 'Sales Engineering' },
            { slug: 'partnerships-and-channel', name: 'Partnerships & Channel' },
            { slug: 'business-development', name: 'Business Development' },
            { slug: 'sales-operations-and-enablement', name: 'Sales Operations & Enablement' },
            { slug: 'inside-sales-and-telesales', name: 'Inside Sales & Telesales' },
            { slug: 'retail-and-field-sales', name: 'Retail & Field Sales' },
            { slug: 'real-estate-and-leasing', name: 'Real Estate & Leasing' },
            { slug: 'sales-leadership', name: 'Sales Leadership' },
        ],
    },
    {
        slug: 'customer-success-and-support',
        name: 'Customer Success & Support',
        subcategories: [
            { slug: 'customer-support', name: 'Customer Support' },
            { slug: 'technical-support', name: 'Technical Support' },
            { slug: 'customer-success-manager', name: 'Customer Success Manager' },
            { slug: 'onboarding-and-implementation', name: 'Onboarding & Implementation' },
            { slug: 'call-center-and-contact-center', name: 'Call Center & Contact Center' },
            { slug: 'community-management', name: 'Community Management' },
            { slug: 'trust-and-safety', name: 'Trust & Safety' },
            { slug: 'content-moderation', name: 'Content Moderation' },
            { slug: 'support-operations', name: 'Support Operations' },
        ],
    },
    {
        slug: 'finance-and-accounting',
        name: 'Finance & Accounting',
        subcategories: [
            { slug: 'accounting', name: 'Accounting' },
            { slug: 'bookkeeping', name: 'Bookkeeping' },
            { slug: 'financial-planning-and-analysis', name: 'Financial Planning & Analysis' },
            { slug: 'controller-and-accounting-management', name: 'Controller & Accounting Management' },
            { slug: 'audit', name: 'Audit' },
            { slug: 'tax', name: 'Tax' },
            { slug: 'payroll', name: 'Payroll' },
            { slug: 'treasury', name: 'Treasury' },
            { slug: 'investment-banking-and-private-equity', name: 'Investment Banking & Private Equity' },
            { slug: 'financial-advisory-and-wealth', name: 'Financial Advisory & Wealth' },
            { slug: 'insurance-and-underwriting', name: 'Insurance & Underwriting' },
            { slug: 'actuarial', name: 'Actuarial' },
            { slug: 'credit-and-collections', name: 'Credit & Collections' },
            { slug: 'finance-leadership-cfo', name: 'Finance Leadership (CFO)' },
        ],
    },
    {
        slug: 'human-resources-and-recruiting',
        name: 'Human Resources & Recruiting',
        subcategories: [
            { slug: 'talent-acquisition-and-recruiting', name: 'Talent Acquisition & Recruiting' },
            { slug: 'technical-recruiting', name: 'Technical Recruiting' },
            { slug: 'hr-generalist', name: 'HR Generalist' },
            { slug: 'hr-business-partner', name: 'HR Business Partner' },
            { slug: 'people-operations', name: 'People Operations' },
            { slug: 'compensation-and-benefits', name: 'Compensation & Benefits' },
            { slug: 'learning-and-development', name: 'Learning & Development' },
            { slug: 'employee-relations', name: 'Employee Relations' },
            { slug: 'dei', name: 'DEI' },
            { slug: 'hris-and-people-analytics', name: 'HRIS & People Analytics' },
            { slug: 'hr-leadership', name: 'HR Leadership' },
        ],
    },
    {
        slug: 'legal-and-compliance',
        name: 'Legal & Compliance',
        subcategories: [
            { slug: 'corporate-counsel', name: 'Corporate Counsel' },
            { slug: 'litigation-and-attorney', name: 'Litigation & Attorney' },
            { slug: 'paralegal-and-legal-assistant', name: 'Paralegal & Legal Assistant' },
            { slug: 'contracts-management', name: 'Contracts Management' },
            { slug: 'ip-and-patent', name: 'IP & Patent' },
            { slug: 'regulatory-affairs', name: 'Regulatory Affairs' },
            { slug: 'compliance-and-aml', name: 'Compliance & AML' },
            { slug: 'privacy-and-data-protection', name: 'Privacy & Data Protection' },
            { slug: 'legal-operations', name: 'Legal Operations' },
        ],
    },
    {
        slug: 'operations-strategy-and-administration',
        name: 'Operations, Strategy & Administration',
        subcategories: [
            { slug: 'business-operations', name: 'Business Operations' },
            { slug: 'revenue-operations', name: 'Revenue Operations' },
            { slug: 'strategy-and-corporate-development', name: 'Strategy & Corporate Development' },
            { slug: 'management-consulting', name: 'Management Consulting' },
            { slug: 'executive-assistant', name: 'Executive Assistant' },
            { slug: 'administrative-assistant', name: 'Administrative Assistant' },
            { slug: 'office-management', name: 'Office Management' },
            { slug: 'data-entry', name: 'Data Entry' },
            { slug: 'procurement-and-sourcing', name: 'Procurement & Sourcing' },
            { slug: 'facilities-and-property-management', name: 'Facilities & Property Management' },
            { slug: 'general-management', name: 'General Management' },
            { slug: 'vendor-management', name: 'Vendor Management' },
        ],
    },
    {
        slug: 'engineering-and-architecture',
        name: 'Engineering & Architecture',
        subcategories: [
            { slug: 'mechanical-engineering', name: 'Mechanical Engineering' },
            { slug: 'electrical-engineering', name: 'Electrical Engineering' },
            { slug: 'civil-and-structural-engineering', name: 'Civil & Structural Engineering' },
            { slug: 'chemical-engineering', name: 'Chemical Engineering' },
            { slug: 'industrial-and-manufacturing-engineering', name: 'Industrial & Manufacturing Engineering' },
            { slug: 'aerospace-engineering', name: 'Aerospace Engineering' },
            { slug: 'biomedical-engineering', name: 'Biomedical Engineering' },
            { slug: 'environmental-engineering', name: 'Environmental Engineering' },
            { slug: 'energy-and-petroleum-engineering', name: 'Energy & Petroleum Engineering' },
            { slug: 'cad-and-drafting', name: 'CAD & Drafting' },
            { slug: 'architecture', name: 'Architecture' },
            { slug: 'surveying-and-geospatial', name: 'Surveying & Geospatial' },
            { slug: 'engineering-management', name: 'Engineering Management' },
        ],
    },
    {
        slug: 'skilled-trades-construction-and-manufacturing',
        name: 'Skilled Trades, Construction & Manufacturing',
        subcategories: [
            { slug: 'electrician', name: 'Electrician' },
            { slug: 'plumbing-and-hvac', name: 'Plumbing & HVAC' },
            { slug: 'carpentry', name: 'Carpentry' },
            { slug: 'welding-and-fabrication', name: 'Welding & Fabrication' },
            { slug: 'machining-and-cnc', name: 'Machining & CNC' },
            { slug: 'construction-labor', name: 'Construction Labor' },
            { slug: 'site-supervision-and-superintendent', name: 'Site Supervision & Superintendent' },
            { slug: 'heavy-equipment-operation', name: 'Heavy Equipment Operation' },
            { slug: 'manufacturing-and-assembly', name: 'Manufacturing & Assembly' },
            { slug: 'maintenance-and-repair-technician', name: 'Maintenance & Repair Technician' },
            { slug: 'quality-control-and-inspection', name: 'Quality Control & Inspection' },
            { slug: 'automotive-and-diesel-technician', name: 'Automotive & Diesel Technician' },
            { slug: 'landscaping-and-grounds', name: 'Landscaping & Grounds' },
            { slug: 'estimating', name: 'Estimating' },
            { slug: 'production-management', name: 'Production Management' },
        ],
    },
    {
        slug: 'transportation-logistics-and-supply-chain',
        name: 'Transportation, Logistics & Supply Chain',
        subcategories: [
            { slug: 'truck-driving-cdl', name: 'Truck Driving (CDL)' },
            { slug: 'delivery-and-courier', name: 'Delivery & Courier' },
            { slug: 'rideshare-and-chauffeur', name: 'Rideshare & Chauffeur' },
            { slug: 'warehouse-and-fulfillment', name: 'Warehouse & Fulfillment' },
            { slug: 'inventory-and-materials', name: 'Inventory & Materials' },
            { slug: 'supply-chain-planning', name: 'Supply Chain Planning' },
            { slug: 'logistics-coordination', name: 'Logistics Coordination' },
            { slug: 'dispatch', name: 'Dispatch' },
            { slug: 'fleet-management', name: 'Fleet Management' },
            { slug: 'aviation-and-flight-crew', name: 'Aviation & Flight Crew' },
            { slug: 'maritime-and-rail', name: 'Maritime & Rail' },
            { slug: 'shipping-and-receiving', name: 'Shipping & Receiving' },
        ],
    },
    {
        slug: 'healthcare-life-sciences-and-research',
        name: 'Healthcare, Life Sciences & Research',
        subcategories: [
            { slug: 'nursing', name: 'Nursing' },
            { slug: 'physicians-and-surgeons', name: 'Physicians & Surgeons' },
            { slug: 'allied-health-and-therapy', name: 'Allied Health & Therapy' },
            { slug: 'mental-and-behavioral-health', name: 'Mental & Behavioral Health' },
            { slug: 'dental', name: 'Dental' },
            { slug: 'pharmacy', name: 'Pharmacy' },
            { slug: 'veterinary', name: 'Veterinary' },
            { slug: 'medical-assisting', name: 'Medical Assisting' },
            { slug: 'laboratory-and-diagnostics', name: 'Laboratory & Diagnostics' },
            { slug: 'clinical-research', name: 'Clinical Research' },
            { slug: 'biotech-and-pharma-randd', name: 'Biotech & Pharma R&D' },
            { slug: 'medical-devices', name: 'Medical Devices' },
            { slug: 'healthcare-administration', name: 'Healthcare Administration' },
            { slug: 'public-health', name: 'Public Health' },
            { slug: 'scientific-research', name: 'Scientific Research' },
        ],
    },
    {
        slug: 'education-and-training',
        name: 'Education & Training',
        subcategories: [
            { slug: 'k-12-teaching', name: 'K-12 Teaching' },
            { slug: 'higher-education-and-faculty', name: 'Higher Education & Faculty' },
            { slug: 'early-childhood-education', name: 'Early Childhood Education' },
            { slug: 'special-education', name: 'Special Education' },
            { slug: 'tutoring-and-test-prep', name: 'Tutoring & Test Prep' },
            { slug: 'instructional-design', name: 'Instructional Design' },
            { slug: 'corporate-training-and-enablement', name: 'Corporate Training & Enablement' },
            { slug: 'school-administration', name: 'School Administration' },
            { slug: 'academic-advising-and-student-services', name: 'Academic Advising & Student Services' },
            { slug: 'coaching', name: 'Coaching' },
            { slug: 'edtech', name: 'EdTech' },
            { slug: 'librarian-and-archivist', name: 'Librarian & Archivist' },
        ],
    },
    {
        slug: 'hospitality-retail-and-personal-services',
        name: 'Hospitality, Retail & Personal Services',
        subcategories: [
            { slug: 'restaurant-and-food-service', name: 'Restaurant & Food Service' },
            { slug: 'culinary-and-chef', name: 'Culinary & Chef' },
            { slug: 'bartending-and-barista', name: 'Bartending & Barista' },
            { slug: 'hotel-and-lodging', name: 'Hotel & Lodging' },
            { slug: 'retail-associate', name: 'Retail Associate' },
            { slug: 'store-and-retail-management', name: 'Store & Retail Management' },
            { slug: 'merchandising', name: 'Merchandising' },
            { slug: 'travel-and-tourism', name: 'Travel & Tourism' },
            { slug: 'events-and-catering', name: 'Events & Catering' },
            { slug: 'beauty-and-personal-care', name: 'Beauty & Personal Care' },
            { slug: 'fitness-and-wellness', name: 'Fitness & Wellness' },
            { slug: 'childcare-and-caregiving', name: 'Childcare & Caregiving' },
            { slug: 'cleaning-and-janitorial', name: 'Cleaning & Janitorial' },
            { slug: 'security-and-guard-services', name: 'Security & Guard Services' },
        ],
    },
    {
        slug: 'public-sector-nonprofit-and-social-services',
        name: 'Public Sector, Nonprofit & Social Services',
        subcategories: [
            { slug: 'government-administration', name: 'Government Administration' },
            { slug: 'public-policy-and-government-affairs', name: 'Public Policy & Government Affairs' },
            { slug: 'social-work-and-case-management', name: 'Social Work & Case Management' },
            { slug: 'nonprofit-program-management', name: 'Nonprofit Program Management' },
            { slug: 'fundraising-and-development', name: 'Fundraising & Development' },
            { slug: 'grant-writing-and-management', name: 'Grant Writing & Management' },
            { slug: 'law-enforcement', name: 'Law Enforcement' },
            { slug: 'emergency-services-and-emt', name: 'Emergency Services & EMT' },
            { slug: 'military-and-defense', name: 'Military & Defense' },
            { slug: 'community-outreach', name: 'Community Outreach' },
            { slug: 'international-development', name: 'International Development' },
            { slug: 'sustainability-and-environment', name: 'Sustainability & Environment' },
        ],
    },
];
export const CATEGORY_COUNT = 19;
export const SUBCATEGORY_COUNT = 226;
const CATEGORY_BY_SLUG = new Map(TAXONOMY.map((c) => [c.slug, c]));
const SUBCATEGORY_BY_KEY = new Map(TAXONOMY.flatMap((c) => c.subcategories.map((s) => [`${c.slug}/${s.slug}`, s])));
/** Look up a category by slug, or undefined when the slug is not in the taxonomy. */
export function getCategory(categorySlug) {
    return CATEGORY_BY_SLUG.get(categorySlug);
}
/** Look up a subcategory by its parent category slug and its own slug. */
export function getSubcategory(categorySlug, subcategorySlug) {
    return SUBCATEGORY_BY_KEY.get(`${categorySlug}/${subcategorySlug}`);
}
/** True when the category exists. */
export function isValidCategory(categorySlug) {
    return CATEGORY_BY_SLUG.has(categorySlug);
}
/** True when the subcategory exists AND is a child of the given category. */
export function isValidScope(categorySlug, subcategorySlug) {
    return SUBCATEGORY_BY_KEY.has(`${categorySlug}/${subcategorySlug}`);
}
/** Human-readable "Category → Subcategory" label, for UI breadcrumbs. */
export function scopeLabel(categorySlug, subcategorySlug) {
    const category = getCategory(categorySlug);
    const subcategory = getSubcategory(categorySlug, subcategorySlug);
    if (!category || !subcategory)
        return undefined;
    return `${category.name} → ${subcategory.name}`;
}
//# sourceMappingURL=taxonomy.js.map